import React from "react";
import { useTranslation } from "react-i18next";
import { AccountCircleOutlined } from "@mui/icons-material";
import styled from "@emotion/styled";
import { PathConstant } from "@/const";
import { AppLink, AppMenuItem } from "@/components/common";

const MenuItemStyled = styled(AppMenuItem)({
  width: 250,
});

const DemoAppLink = () => {
  const { t: getLabel } = useTranslation();

  return (
    <AppLink to={PathConstant.PROFILE} key="infoDemo" underline="none" color="inherit">
      <MenuItemStyled startIcon={<AccountCircleOutlined />} text={getLabel("OBJ_MENU_HEADER.info")} />
    </AppLink>
  );
};

export default DemoAppLink;
